(function () {
  "use strict";

  function play(video) {
    if (!video || document.hidden) return;
    var playback = video.play();
    if (playback && playback.catch) playback.catch(function () {});
  }

  function setupHero() {
    var video = document.getElementById("engagement-hero-loop");
    if (!video) return;
    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)");
    var mobile = window.matchMedia("(max-width: 720px)").matches;
    var poster = mobile ? window.AALandingAssets.heroPosterMobile : window.AALandingAssets.heroPoster;
    var sourceUrl = mobile ? window.AALandingAssets.heroVideoMobile : window.AALandingAssets.heroVideo;

    video.defaultMuted = true;
    video.muted = true;
    video.volume = 0;
    video.playsInline = true;
    video.loop = true;

    function applyMotion() {
      video.poster = poster;
      Array.from(video.querySelectorAll("source")).forEach(function (source) { source.remove(); });
      if (reduced.matches) {
        video.pause();
        video.removeAttribute("autoplay");
        video.preload = "none";
        video.load();
        return;
      }
      var source = document.createElement("source");
      source.type = "video/mp4";
      source.src = sourceUrl;
      video.appendChild(source);
      video.setAttribute("autoplay", "");
      video.preload = "auto";
      video.load();
      play(video);
    }

    reduced.addEventListener("change", applyMotion);
    document.addEventListener("visibilitychange", function () { play(video); });
    window.addEventListener("pageshow", function () { play(video); });
    video.addEventListener("ended", function () { video.currentTime = 0; play(video); });
    applyMotion();
  }

  function setupProofCarousel() {
    var viewport = document.querySelector(".if-proof-viewport");
    if (!viewport) return;
    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function move(direction) {
      var card = viewport.querySelector(".if-proof-card");
      if (!card) return;
      viewport.scrollBy({
        left: direction * (card.getBoundingClientRect().width + 16),
        behavior: reduced ? "auto" : "smooth",
      });
    }

    var previous = document.querySelector("[data-proof-prev]");
    var next = document.querySelector("[data-proof-next]");
    if (previous) previous.addEventListener("click", function () { move(-1); });
    if (next) next.addEventListener("click", function () { move(1); });
    viewport.addEventListener("keydown", function (event) {
      if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
      event.preventDefault();
      move(event.key === "ArrowLeft" ? -1 : 1);
    });

    var startX = 0;
    var startScroll = 0;
    var dragging = false;
    viewport.addEventListener("pointerdown", function (event) {
      if (event.pointerType !== "mouse" || event.button !== 0) return;
      dragging = true;
      startX = event.clientX;
      startScroll = viewport.scrollLeft;
      viewport.classList.add("is-dragging");
      viewport.setPointerCapture(event.pointerId);
    });
    viewport.addEventListener("pointermove", function (event) {
      if (dragging) viewport.scrollLeft = startScroll - (event.clientX - startX);
    });
    function finish(event) {
      if (!dragging) return;
      dragging = false;
      viewport.classList.remove("is-dragging");
      if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
    }
    viewport.addEventListener("pointerup", finish);
    viewport.addEventListener("pointercancel", finish);
  }

  function setupReveals() {
    var elements = Array.from(document.querySelectorAll("[data-reveal]"));
    if (!elements.length || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    elements.forEach(function (element) {
      element.style.opacity = "0";
      element.style.transform = "translateY(20px)";
      element.style.willChange = "opacity, transform";
    });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, index) {
        if (!entry.isIntersecting) return;
        entry.target.style.transition = "opacity 0.8s cubic-bezier(0.2,0.6,0.2,1) " + (index * 100) + "ms, transform 0.8s cubic-bezier(0.2,0.6,0.2,1) " + (index * 100) + "ms";
        entry.target.style.opacity = "1";
        entry.target.style.transform = "translateY(0)";
        observer.unobserve(entry.target);
      });
    }, { rootMargin: "0px 0px 4%" });
    elements.forEach(function (element) { observer.observe(element); });
  }

  setupHero();
  setupProofCarousel();
  setupReveals();
})();
